export const BUILDINGS_OPTIONS = {
  countries: ["france"],
  departments: ["var"],
};
